/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum ProductionMaterialType {
    Unknown = 0,
    Wood = 1,
    Synthetic = 2,
    Stone = 3,
    Metal = 4,
    Carbon = 5,
    Plaster = 6,
    Trespa = 7,
}
